<template>
  <div class="pay_box">
    <!-- 微信二维码 -->
    <div class="user_teacher" v-if="success">
      <div class="flexbox img_qrcode">
        <img class="img" :src="user.adviserErCode" />
      </div>
      <div class="img_text">请务必{{ isNative ? '截图' : '' }}扫码进入班级群</div>
    </div>
  </div>
</template>

<script>
// import { defaultAdviserImg } from '@/pages/config'
import { appUser } from '@/utils'
export default {
  name: 'PayUser',
  props: {
    user: Object,
    success: { type: Boolean, default: true },
    goodsId: [Number, String]
  },
  data() {
    return {
      // defaultAdviserImg
    }
  },
  computed: {
    isNative() {
      return appUser.isNative
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.pay_box {
  width: 6.86rem;
  height: 8.38rem;
  background: #ffffff;
  border-radius: 0.16rem;
  box-shadow: 0rem 0rem 0.22rem 0rem rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 3rem;
  left: 50%;
  transform: translateX(-50%);
  .user_teacher {
    text-align: center;
    .img_qrcode {
      margin: 1.2rem auto 0.44rem;
      width: 2.8rem;
      height: 2.8rem;
      background: #ffffff;
      border-radius: 0.16rem;
      box-shadow: 0rem 0rem 0.22rem 0rem rgba(0, 0, 0, 0.1);
      justify-content: center;
      .img {
        display: block;
        width: 2.4rem;
        height: 2.4rem;
      }
    }
    .img_text {
      font-size: 0.28rem;
      font-weight: 600;
      color: #00b25a;
    }
  }
}
</style>
